import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";
import { Storage } from "@ionic/storage";

@Injectable({
  providedIn: "root",
})
export class NivelaccesoGuard implements CanActivate {
  constructor(private storage: Storage, private router: Router) {}
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const usuario = await this.storage.get("usuario");
    let roles = route.data.roles as Array<string>;
    if (roles.includes(usuario.nivelacceso)) {
      return true;
    } else {
      this.router.navigateByUrl("/home");
    }
  }
}
